import { h, defineComponent } from 'vue';
import { apiErrorMessage, box, button, container, pageSubtitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { useSetBrowserLocale } from '@/ui/concerns';
import { ApiError } from '@/services/api';
import { unsetToken } from '@/services/token';

interface ErrorFetchingUserPageProps {
  error: ApiError;
}

export const ErrorFetchingUserPage = defineComponent<ErrorFetchingUserPageProps>({
  name: 'ErrorFetchingUserPage',
  props: ['error'],
  setup(props) {
    // since we don't know the logged in user's locale, we use the browser's locale
    useSetBrowserLocale();

    return () => h('div', { class: 'p-12' }, [container(
      [
        box([
          pageSubtitle(t('error.fetching-account')),
          h('div', { class: 'content' }, t('error.unable-fetch-account')),
          apiErrorMessage({
            pending: false,
            error: props.error,
          }),
          button(t('common.retry'), () => {
            unsetToken();
            window.location.reload();
          }),
        ]),
      ],
      'small',
    )]);
  },
});
